import styled from "styled-components";

export const StatCardsRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;

const VARIANT_COLORS: Record<string, { accent: string; background: string }> = {
  blue: { accent: '#2563EB', background: '#EFF6FF' },
  green: { accent: '#15803D', background: '#F0FDF4' },
};

export const StatCard = styled.div<{ $variant?: string }>`
  flex: 1;
  min-width: 220px;
  background: ${(props) => VARIANT_COLORS[props.$variant || 'blue'].background};
  border: 1px solid var(--gray-light);
  border-left: 4px solid ${(props) => VARIANT_COLORS[props.$variant || 'blue'].accent};
  border-radius: 12px;
  padding: 20px 24px;

  body.high-contrast & {
    background: #000 !important;
    border-color: #ffff00 !important;
  }
`;

export const StatCardLabel = styled.span`
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--neutral-light);
  margin-bottom: 8px;
`;

export const StatCardValue = styled.span<{ $variant?: string }>`
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${(props) => VARIANT_COLORS[props.$variant || 'blue'].accent};
`;
